import styled from '@emotion/styled/macro'

import { pageContentDefaultSize } from 'style/emotion'
import mediaQuery from 'share/utils/mediaQuery'

const QuestionnaireTermsAndConditionsPage = styled('section')`
  ${pageContentDefaultSize}

  color: var(--CINight);
  margin-top: 48px;

  > h2 {
    margin-bottom: 16px;
    color: var(--print-main);
  }

  .accept-terms {
    margin-bottom: 32px;
    .accept-terms-checkbox {
      .form-check-input {
        margin-top: 7px;
      }
      .form-check-label {
        margin-top: 2px;
      }
    }
  }

  ${mediaQuery('tablet')} {
    margin-top: 24px;
  }
`

const QuestionnaireTermsAndConditionsContainer = styled('div')`
  margin-top: 16px;
  font-size: 14px;
  font-weight: 400;
  white-space: pre-line;

  margin-bottom: 16px;
`

export {
  QuestionnaireTermsAndConditionsPage,
  QuestionnaireTermsAndConditionsContainer
}
